export enum Environment {
  PROD = "production",
  DEV = "develop",
  LOCAL = "local",
}
